module.exports = __webpack_public_path__ + "static/media/facebook_sign_in.5e8c7f5e.png";